import {LOCALES} from '../locales';

export default {
    [LOCALES.ENGLISH]: {
        'zgjidh': 'Choose the service you need',
        'webservice' : 'Website',
        'appservice': 'Mobile Application',
        'serviceother': 'Services',
        'pytja1':'What is the typology of your business?',
        'alternativa1pytja1':'Informative',
        'alternativa2pytja1':'E-commerce',
        'alternativa3pytja1':'Booking',
        'alternativa4pytja1':'Portals',
        'alternativa5pytja1':'Delivery',
        'alternativa6pytja1':'Web Reference',
        'pytj1a':'How many products will the web contain?',
        'pytj1b':'Who is going to publish the needed materials for the website?',
        'alternativa1pytj1b':'The third party',
        'pytj1c':'What is the platform on which the web will be built?',
        'pytj1d':'Which payment method would you like to apply in your website?',
        'pytja2':'WEB Design Requirements',
        'alternativa1pytja2': 'Simple',
        'alternativa2pytja2':'Advanced',
        'alternativa3pytja2':'Complex',
        'pytja3': 'How many languages will be on your web?',
        'alternativa1pytja3': 'A language',
        'alternativa2pytja3': 'Many language',
        'pytja4': 'Who is going to publish the needed materials for the website?',
        'alternativa1pytja4': 'Client',
        'pytja5': 'How many main pages does the web have?',
        'pytja6': 'Do you have a host and domain?',
        'alternativa1pytja6': 'I have none',
        'alternativa2pytja6': 'I have Host',
        'alternativa3pytja6': 'I have Domain',
        'alternativa4pytja6': 'I have Host & Domain',
        'pytja7': 'How Important Is Your Web Ranking In Search Engines?',
        'alternativa1pytja7': 'Not at all important',
        'alternativa2pytja7': 'A little important',
        'alternativa3pytja7': 'Important',
        'alternativa4pytja7': 'Very important',
        'pytja8': 'On the web there will be elements like:',
        'alternativa1pytja8':'Articles',
        'alternativa2pytja8':`FAQ's`,
        'alternativa3pytja8':'Live Chat',
        'alternativa4pytja8':'User Profile',
        'alternativa5pytja8':'Reservations / Event Calendar',
        'domarketing':'Want marketing?',
        'pytja9':'Your business needs:',
        'alternativa1pytja9':'Name',
        'alternativa2pytja9' :'Brand Image',
        'alternativa3pytja9':'All three',
        'pytja10':'Want Social Media Management?',
        'pytja10a':'What is the frequency of media posts during the week?',
        'pytja11':'Do you need a photo set?',
        'pytja11a':'How many times per month?',
        'alternativa1pytja11a':'1 time per month',
        'alternativa2pytja11a':'2 times per month',
        'pytja12':'Want marketing campaign?',
        'pytja12a':'Where do you want to be promoted?',
        'alternativa1pytja12a':'Everywhere',
        'pytja13':'Do you want to register the trademark legally?',
        'titulliformes':'Fill in the fields by sending us the request details automatically',
        'dowebsite':'Want webiste?',
        'personalizo':'Personalize',
        'dergo':'Send',
        'emri': 'Name',
        'phone':'Phone Number',
        'link':'Link of Web',
        'kerkesa':'New request',
        'rinovim':'Renewal',
        'brandiri':'New',
        'doBrandTeRi':'Would you like a brand renewal or a new brand?',
        'appTitle':`Specify in detail the requirements and functionalities of the application`,
        'alternativa':'you can choose more than one option',
        'faqet':'Home, About Us, Services, Gallery, Contact',
        }
}

